/* eslint-disable consistent-return */
import api from './config';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
const initialState = {
  isLoading: false,
  error: null,
  response: null,
  isSignupFulfilled: false
};
export const signUpMethod = createAsyncThunk(
  'signUp/submitForms',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post('/auth/signup-client', formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const signUpGoogle = createAsyncThunk(
  'auth/signUpWithGoogle',
  async (_, { rejectWithValue }) => {
    try {
      const rawBackendUrl = process.env.REACT_APP_BACKEND_URL || '';
      const backendUrl = rawBackendUrl.replace(/^['"]|['"]$/g, '') || 'https://api.woinfos.com';
      window.location.href = new URL('/auth/google', backendUrl).toString();
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const signUpFacebook = createAsyncThunk(
  'auth/signUpWithFacebook',
  async (_, { rejectWithValue }) => {
    try {
      const rawBackendUrl = process.env.REACT_APP_BACKEND_URL || '';
      const backendUrl = rawBackendUrl.replace(/^['"]|['"]$/g, '') || 'https://api.woinfos.com';
      window.location.href = new URL('/auth/facebook', backendUrl).toString();
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const confirmPhone = createAsyncThunk(
  'signUp/confirmPhone',
  async (confirmPhoneDTO, { rejectWithValue }) => {
    try {
      const response = await api.post('/auth/confirm-phone', confirmPhoneDTO);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const verifyCodeClient = createAsyncThunk(
  'signUp/verify-code-client',
  async (codeData, { rejectWithValue }) => {
    try {

      const response = await api.post('auth/verify-code-client', codeData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const formSlice = createSlice({
  name: 'signUp',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(signUpMethod.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.response = null;
      })
      .addCase(signUpMethod.fulfilled, (state, action) => {
        state.isLoading = false;
        state.response = action.payload;
        state.isSignupFulfilled = true; // Set isSignupFulfilled to true
      })
      .addCase(signUpMethod.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        state.isSignupFulfilled = false;
      })
      .addCase(confirmPhone.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.response = null;
      })
      .addCase(confirmPhone.fulfilled, (state, action) => {
        state.isLoading = false;
        state.response = action.payload;
        state.isSignupFulfilled = true; // Set isSignupFulfilled to true
      })
      .addCase(confirmPhone.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        state.isSignupFulfilled = false;
      })
      .addCase(signUpGoogle.fulfilled, (state, action) => {
        state.isLoading = false;
        state.response = action.payload;
        state.isSignupFulfilled = true; // Set isSignupFulfilled to true
      })
      .addCase(signUpGoogle.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        state.isSignupFulfilled = false;
      })
      .addCase(signUpFacebook.fulfilled, (state, action) => {
        state.isLoading = false;
        state.response = action.payload;
        state.isSignupFulfilled = true; // Set isSignupFulfilled to true
      })
      .addCase(signUpFacebook.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        state.isSignupFulfilled = false;
      })
      .addCase(verifyCodeClient.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.response = null;
      })
      .addCase(verifyCodeClient.fulfilled, (state, action) => {
        state.isLoading = false;
        //console.log(action.payload)
        state.response = action.payload;
        state.isSignupFulfilled = true; // Set isSignupFulfilled to true
      })
      .addCase(verifyCodeClient.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        state.isSignupFulfilled = false;
      });
  }
});

export const { setSignupFulfilled } = formSlice.actions;

export default formSlice.reducer;
